var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.item.source === 'uploaded')?[_vm._v(" "+_vm._s(_vm.$t("riskAssessment.source.uploaded"))+" ")]:[_vm._v(" "+_vm._s(_vm.item.kind === "advanced" ? _vm.$t("riskAssessment.kind.advancedShort") : _vm.$t("riskAssessment.kind.basicShort"))+" ")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }